/* eslint-disable no-new */

import Swiper from 'swiper';
import { Navigation, A11y, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const $blockCarouselPromo = document.querySelectorAll('.block-promo-swiper .swiper');
    const $blockNewsEvents = document.querySelectorAll('.block-news-events .swiper');
    const lang = document.documentElement.lang === 'fr-CA';
    const elementMessage = lang ? 'Carrousel d\'éléments' : 'Elements carousel';
    const nextElement = lang ? 'Élément suivant' : 'Next element';
    const prevElement = lang ? 'Élément précédent' : 'Previous element';

    $blockCarouselPromo.forEach((element) => {
        const parentContainer = element.closest('.block-promo-swiper');
        const btnPrev = parentContainer.querySelector('.button-swiper-prev');
        const btnNext = parentContainer.querySelector('.button-swiper-next');
        // init swiper
        new Swiper(element, {
            modules: [Navigation, A11y, Pagination],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            a11y: {
                enabled: true,
                containerMessage: elementMessage,
                prevSlideMessage: prevElement,
                nextSlideMessage: nextElement,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet(index, className) {
                    return `<span class='${className}'>${index + 1}</span>`;
                },
            },
        });
    });

    const swiperNewsEvents = [];

    function initNewsEventsCarousels() {
        const isMobile = window.matchMedia('(max-width: 1024px)').matches;

        $blockNewsEvents.forEach((element, index) => {
            const parentContainer = element.closest('.block-news-events');
            const btnPrev = parentContainer.querySelector('.button-swiper-prev');
            const btnNext = parentContainer.querySelector('.button-swiper-next');

            if (isMobile && !swiperNewsEvents[index]) {
                swiperNewsEvents[index] = new Swiper(element, {
                    modules: [Navigation, A11y],
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    navigation: {
                        nextEl: btnNext,
                        prevEl: btnPrev,
                    },
                    breakpoints: {
                        1024: {
                            spaceBetween: 32,
                        },
                    },
                    a11y: {
                        enabled: true,
                        containerMessage: elementMessage,
                        prevSlideMessage: prevElement,
                        nextSlideMessage: nextElement,
                    },
                });
            } else if (!isMobile && swiperNewsEvents[index]) {
                swiperNewsEvents[index].destroy(true, true);
                swiperNewsEvents[index] = null;
            }
        });
    }
    window.addEventListener('load', initNewsEventsCarousels);
    window.addEventListener('resize', initNewsEventsCarousels);
});
